export const LOAD_VEHICLE = '[VEHICLE]: Load vehicle';
